/*eslint-disable import/default */
import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import routes from './routes';

// THEMING
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {grey800, lightBlue500} from 'material-ui/styles/colors';

// webpack can import CSS files too
import './styles/styles.scss';
import 'flexboxgrid/dist/flexboxgrid.css';

import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

const store = configureStore();

const muiTheme = getMuiTheme({
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: lightBlue500,
    primary2Color: lightBlue500,
    primary3Color: lightBlue500,
    textColor: grey800
  },
  appBar: {
    height: 50
  }
});

render(
  <MuiThemeProvider muiTheme={muiTheme}>
    <Provider store={store}>
      <Router history={browserHistory} routes={routes} />
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('app')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/